import React, { useEffect, useMemo } from 'react';
import { useApplicationNavigation } from '../hooks/useApplicationNavigation';
import { useDispatch, useSelector } from 'react-redux';
import { hasILRImageSelector } from '../../layout/selectors/layout.selectors';
import { sendAnalyticsPage } from '../../analytics/thunks/sendAnalyticsPage.thunk';
import { leadCountSelector } from '../selectors/signal.selectors';
import { ApplicationPath } from '../types/application-path.types';

export const ViewPicker: React.FC = () => {
  const navigate = useApplicationNavigation();
  const hasILRImage = useSelector(hasILRImageSelector);
  const leadCount = useSelector(leadCountSelector);
  const dispatch = useDispatch();
  const defaultPath: ApplicationPath = useMemo(
    () => (leadCount === 12 ? 'resting' : hasILRImage ? 'ilr' : 'hr'),
    [leadCount, hasILRImage],
  );

  useEffect(() => {
    dispatch(sendAnalyticsPage(`page:${defaultPath}`));
    navigate(defaultPath);
  }, [defaultPath, dispatch, navigate]);

  return <></>;
};
